import { EmsgInfo } from '../../EmsgInfo';

export interface EmsgEvent {
  [key: string]: any;
  calculatedPresentationTime: number;
  duration: number;
  eventStream: {
    adaptionSet: null;
    period: null;
    representation: any;
    schemeIdUri: string;
    timescale: number;
    value: string;
    id: number;
    messageData: Uint8Array;
    presentationTime: number;
    presentationTimeDelta: number;
  };
}

function convertDashJSMessageToEmsg(evt: EmsgEvent): EmsgInfo {
  return {
    id: evt.id,
    messageData: evt.messageData,
    timescale: evt.timescale,
    presentationTimeDelta: evt.presentationTimeDelta,
    schemeIdUri: evt.schemeIdUri,
    value: evt.value,
    startTime: 0,
    endTime: 0,
    eventDuration: 0,
  };
}

export { convertDashJSMessageToEmsg };
